import { render, staticRenderFns } from "./ProfileRight.vue?vue&type=template&id=7b71f0de&scoped=true"
import script from "./ProfileRight.vue?vue&type=script&lang=ts"
export * from "./ProfileRight.vue?vue&type=script&lang=ts"
import style0 from "./ProfileRight.vue?vue&type=style&index=0&id=7b71f0de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b71f0de",
  null
  
)

export default component.exports